
































































import {Component, Vue} from 'vue-property-decorator';
import {mapFields} from 'vuex-map-fields';
import MediaDetailDialog from '@/components/dialogs/MediaDetailDialog.vue';

/**
 * Chunk display item component
 * works for content and instant chunks
 */
@Component({
    components: {
        MediaDetailDialog
    },
    props: {
        /**
         * Whether the component should be highlighted
         */
        isHighlighted: {
            type: Boolean
        }
    },
    computed: mapFields('settings', [
        'show_timestamps',
        'show_media',
        'text_size',
    ])
})
export default class DisplayItemChunk extends Vue {

    private formatTimestamp(timestamp: string) {

        // Remove date
        timestamp = timestamp.split(' ')[1];

        // Remove millis
        timestamp = timestamp.split('.')[0];

        return timestamp;
    }
}
